import { FC } from 'react';

import CloseIcon from '@mui/icons-material/Close';
import { SxProps, Theme } from '@mui/material';

import { CloseButtonContainer, CloseIconButton } from '../ImagesModalVersioning/ImageSlider.styles';

interface DialogCloseButtonProps {
  onClick: () => void;
  sx?: SxProps<Theme>;
  'data-testid'?: string;
}

const DialogCloseButton: FC<DialogCloseButtonProps> = ({ onClick, sx, 'data-testid': testId }) => (
  <CloseButtonContainer sx={{ flexShrink: 0, alignSelf: 'flex-end', mr: '0.5rem', ...sx }}>
    <CloseIconButton data-testid={testId} onClick={onClick} sx={{ color: 'black' }}>
      <CloseIcon />
    </CloseIconButton>
  </CloseButtonContainer>
);

export default DialogCloseButton;
